import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';

@Component({
	moduleId: module.id,
	selector: 'type-of-indebtedness',
	templateUrl: 'type-of-indebtedness.component.html',
	providers: [
		CommonService
	]
})
export class TypeOfIndebtednessComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";	
	@Input('isProposalRevenue') isProposalRevenue: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('proposalRevenueDocument') proposalRevenueDocument: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	private token;
	public types: any[] = [];
	public editTypeIndex: number = undefined;
	typeof: FormGroup;

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {
		this.typeof = fb.group({
			ID: '',
			TipoEndividamentoID: ['', Validators.compose([Validators.required])],
			CurtoPrazo: ['', Validators.compose([Validators.required])],
			LongoPrazo: ['', Validators.compose([Validators.required])]
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		this.getType();
	}

	saveProposalypesOfIndebtedness(typeofinteb: any) {
		typeofinteb.Documento = this.proposalRevenueDocument;
		this.limitFlowProposalService.typeOfObj.push(typeofinteb);
		this.flashMessagesService.show("Tipo de endividamento adicionado", { cssClass: 'alert-success', timeout: 6000 });
		this.typeof.reset();
	}

	deleteProposalypesOfIndebtedness(index) {
		this.limitFlowProposalService.typeOfObj.splice(index, 1);
		this.flashMessagesService.show("Tipo de endividamento removido", { cssClass: 'alert-success', timeout: 6000 });
	}

	// NOTA: O serviço não existe!
	getProposalTypes() {
		if (this.proposalID) {
			this.limitFlowProposalService.getProposalypesOfIndebtedness(this.token, this.proposalID).subscribe(result => {
				if (result.Success) {
					this.limitFlowProposalService.typeOfObj = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	getType() {
		if (this.types.length === 0) {
			this.limitFlowProposalService.getTypes().subscribe(result => {
				if (result.Success) {
					this.types = result.Result;
					//this.getProposalTypes();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
			});
		}
	}

	getTypeCpTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.typeOfObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.typeOfObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.limitFlowProposalService.typeOfObj[i].CurtoPrazo;
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.typeOfObj[i].Documento) {
				sum += this.limitFlowProposalService.typeOfObj[i].CurtoPrazo;
			}
		}

		$("#typeCpTotal").val(sum);

		return sum;
	}

	getTypeLpTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.typeOfObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.typeOfObj[i].Documento === this.proposalRevenueDocument) {
				sum += this.limitFlowProposalService.typeOfObj[i].LongoPrazo;
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.typeOfObj[i].Documento) {
				sum += this.limitFlowProposalService.typeOfObj[i].LongoPrazo;
			}
		}

		$("#typeLpTotal").val(sum);
		
		return sum;
	}

	getDescricao(TipoEndividamentoID) {
		console.log("[getDescricao] : ", TipoEndividamentoID);

		console.log("[getDescricao] : ", this.types);

		var desc; 
		var item = this.types.filter(item => item.ID === TipoEndividamentoID);
		desc = item[0] ? item[0].Tipo : "";
		return desc; 
	}

	editType(index) {
		this.editTypeIndex = index;
		this.typeof.patchValue({
			TipoEndividamentoID: this.limitFlowProposalService.typeOfObj[index].TipoEndividamentoID,
			CurtoPrazo: this.limitFlowProposalService.typeOfObj[index].CurtoPrazo,
			LongoPrazo: this.limitFlowProposalService.typeOfObj[index].LongoPrazo
		});
		($(".type-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".type-form") as any).addClass("editing");
	}

	saveTypeEdit() {
		this.limitFlowProposalService.typeOfObj[this.editTypeIndex].TipoEndividamentoID = this.typeof.controls['TipoEndividamentoID'].value;
		this.limitFlowProposalService.typeOfObj[this.editTypeIndex].CurtoPrazo = this.typeof.controls['CurtoPrazo'].value;
		this.limitFlowProposalService.typeOfObj[this.editTypeIndex].LongoPrazo = this.typeof.controls['LongoPrazo'].value;
		this.editTypeIndex = undefined;
		this.typeof.reset();
		($(".type-list table tbody tr") as any).removeClass("edit-line");
		($(".type-form") as any).removeClass("editing");
	}

	cancelTypeEdit() {
		this.editTypeIndex = undefined;
		($(".type-list table tbody tr") as any).removeClass("edit-line");
		($(".type-form") as any).removeClass("editing");
		this.typeof.reset();
	}
}


// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/type-of-indebtedness/type-of-indebtedness.component.ts